/**
 * 仅按设备身份识别手机访问，不以窗口宽度判断，避免桌面浏览器缩窄窗口时被误提示。
 */
const PHONE_USER_AGENT = /android.+mobile|iphone|ipod|iemobile|windows phone|blackberry|bb10|opera mini|mobile.+firefox|webos/i
const TABLET_USER_AGENT = /ipad|tablet|kindle|silk|playbook/i

function isMobilePhone(navigatorLike) {
  const context = navigatorLike || {}
  const userAgentData = context.userAgentData
  const userAgent = String(context.userAgent || '')

  // iPad 等平板有时也会报告 mobile=true，已识别的平板必须优先排除。
  if (TABLET_USER_AGENT.test(userAgent)) {
    return false
  }

  // Chromium 的低熵 Client Hints 优先级最高，能避免仅靠 UA 字符串产生歧义。
  if (userAgentData && typeof userAgentData.mobile === 'boolean') {
    return userAgentData.mobile
  }

  if (!userAgent) {
    return false
  }

  return PHONE_USER_AGENT.test(userAgent)
}

module.exports = {isMobilePhone}
